import React from 'react';

export const CategoryFilter = ({
                                   categories = [],
                                   selected = [],
                                   toggleCategory,
                                   onClearAll,
                                   label = "בחר קטגוריות:",
                               }) => {
    return (
        <div className="space-y-2 mb-4">
            {/*<h3 className="text-white text-center font-semibold text-md w-full">{label}</h3>*/}
            <div className="flex flex-wrap justify-center gap-2">
                {categories.map((cat) => {
                    const isSelected = selected.includes(cat);
                    return (
                        <button
                            key={cat}
                            onClick={() => toggleCategory(cat)}
                            className={`px-3 py-1 rounded-full border-2 text-sm font-medium transition-all
                                ${
                                isSelected
                                    ? 'bg-warning-500 text-white border-warning-600'
                                    : 'bg-white bg-opacity-100 text-ink-strong border-line-strong hover:bg-warning-100'
                            }`}
                        >
                            {cat}
                        </button>
                    );
                })}
            </div>
            {selected.length > 0 && onClearAll && (
                <div className="flex justify-center mt-2">
                    <button
                        onClick={onClearAll}
                        className="px-4 py-1.5 rounded-lg text-xs font-semibold bg-danger-500 text-white hover:bg-danger-600 transition-all duration-200 shadow-sm hover:shadow-md"
                    >
                        נקה הכל
                    </button>
                </div>
            )}
        </div>
    );
};
